import Tag from 'antd/lib/tag'

import 'antd/lib/tag/style'

export * from 'antd/lib/tag'

export default Tag
